import { useState, useCallback, useEffect } from 'react';

import { fetchFeedback, fetchStatisticFeedbackItems } from '../api/feedback';

const useFeedbackStatistic = (invoiceId) => {
	const [sum, setSum] = useState(0);
	const [list, setList] = useState(null);

	useEffect(() => {
		getData();
	}, []);

	const getData = useCallback(async (callback = () => {}) => {
		const res = await fetchFeedback(invoiceId);
		let feedbacks = res.feedbackItemViewModels;

		if (feedbacks.length > 0) {
			const invoiceItemIds = feedbacks.map((item) => item.invoiceItemId);
			const statistics = await fetchStatisticFeedbackItems(invoiceItemIds);

			feedbacks = feedbacks.map((item, i) => ({
				...item,
				statistic: statistics[i],
			}));
			setList(feedbacks);

			const sumTotal = statistics.reduce((s, item) => s + item.sumTotal, 0);
			setSum(sumTotal);

			callback();
		} else {
			setList([]);
		}
	}, []);

	return {
		sum,
		list,
	};
};

export default useFeedbackStatistic;
